import { BrowserRouter as Router, Route } from 'react-router-dom';

import Home from './Home';
import DnD from './DnD';
import { Switch } from 'react-router-dom/cjs/react-router-dom.min';

const App = () => {

  return <>
    <link href='https://fonts.googleapis.com/css?family=Montserrat&display=swap' rel='stylesheet' type='text/css' />
    <link href='https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap' rel='stylesheet' type='text/css' />

    <Router>
      <Switch>
        <Route exact path='/'>
          <Home />
        </Route>
        <Route exact path='/dnd'>
          <DnD />
        </Route>
        <Route>
          <Home />
        </Route>
      </Switch>
    </Router>
  </>
};

export default App;
